/**
 * @author Owais Liaquat
 * @datetime Nov, 1st 2022
 * @description: This directive is for control disable through that we will disable
 *                controls for unauthorized users
 */

import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { role } from 'src/app/shared/utils/user-roles';

@Directive({
  selector: '[sameUserIdControl]',
})
export class sameUserIdControlDirective {
  role = role;
  userRole: string = this.helperService.getUserRole;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private stateManagementService: StateManagementService,
    private helperService: HelperService
  ) {}

  @Input() set sameUserIdControl(accessDetail: {
    userId: string;
    hide: boolean;
    hideSameAndLowerRoles?: string;
    currentRole?: any;
  }) {
    this.viewContainerRef.clear(); // Remove duplicate DOM elements

    const { userId, hide, hideSameAndLowerRoles, currentRole } = accessDetail;
    const currentUserID = this.stateManagementService.getUser().userId;

    if (this.userRole === this.role.propertyManagerAdmin) {
      if (userId === currentUserID && hide) {
        return; // Do not create the view if it should be hidden
      }
    } else if (hideSameAndLowerRoles === currentRole) {
      return; // Do not create the view if it should be hidden for other roles
    }

    if (userId !== currentUserID) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
